import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	unassignedUser: {
		id: 'polaris-ideas.view-content.idea-matrix.user-field.unassigned-user',
		defaultMessage: 'Unassigned',
		description: 'Tooltip for unassigned user avatar',
	},
});
